import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Settings } from "lucide-react";
import { LogoutButton, LogoutConfirmDialog } from "@/components/auth/LogoutButtonWithConfirm";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import { LanguageSwitcher } from "@/components/layout/LanguageSwitcher";
import { useScrollDirection } from "@/hooks/useScrollDirection";
import { cn } from "@/lib/utils";

export function SuperAdminDesktopHeader() {
  const { t } = useTranslation("common");
  const { scrollDirection, isNearTop } = useScrollDirection(10, 100);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogoutClick = () => {
    setUserMenuOpen(false);
    setTimeout(() => {
      setLogoutDialogOpen(true);
    }, 200);
  };

  return (
    <>
      <header className={cn(
        "auto-hide-header z-40 w-full border-b bg-super-admin-header-bg border-super-admin-header-border hidden lg:block safe-top",
        (scrollDirection === 'down' || (scrollDirection === 'up' && !isNearTop)) && "lg:hidden"
      )}>
        <div className="flex items-center justify-end h-16 px-6 gap-2">
          <ThemeToggle />
          <LanguageSwitcher />
          
          <Popover open={userMenuOpen} onOpenChange={setUserMenuOpen}>
            <PopoverTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="relative text-super-admin-sidebar-text hover:bg-super-admin-sidebar-hover"
                aria-label={t("userMenu", "Menu")}
              >
                <Avatar className="h-8 w-8">
                  <AvatarImage src="" alt="super admin" />
                  <AvatarFallback className="bg-super-admin-sidebar-active text-super-admin-sidebar-text">SA</AvatarFallback>
                </Avatar>
              </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-64 p-0 bg-background" sideOffset={8}>
              <div className="border-b px-4 py-3 bg-muted">
                <p className="font-semibold text-sm">Super Admin</p>
              </div>
              
              <div className="py-1">
                <Link 
                  to="/super-admin/settings" 
                  className="flex items-center w-full px-4 py-2 text-sm hover:bg-muted transition-colors cursor-pointer"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <Settings className="h-4 w-4 mr-2" />
                  <span>{t("settings")}</span>
                </Link>
                
                <div className="h-px bg-border my-1" />
                
                <div className="px-4 py-2">
                  <LogoutButton onClick={handleLogoutClick} />
                </div>
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </header>

      {/* Dialog de confirmation rendu EN DEHORS du Popover */}
      <LogoutConfirmDialog 
        open={logoutDialogOpen} 
        onOpenChange={setLogoutDialogOpen} 
      />
    </>
  );
}
